var image_viewer_rtlignore_default = {
  "fontElementMap": "sKW4h",
  "imageContainer": "Lk4SQ",
  "expandContainer": "W8XEx",
  "expandIcon": "myYdx",
  "pointer": "BjyJS",
  "imageWrapper": "_4KtbX",
  "imageRatio": "WrK8R",
  "image": "yCi5g",
  "imageOverlay": "O9NhC",
  "imagePreload": "FhHi8",
  "imageHighres": "ze7Pd",
  "onlyHighRes": "wAo-P",
  "image_loading": "kGmVk"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
